<template>
    <div id="container" :class="{ 'isMobile': isMobile }" class="hide-scrollbar">
        <!-- ======== Header ======== -->
        <div class="header pc_height">
            <div class="project-title">
                <img src="/logo.png"><span>&nbsp;探数蚁</span>
            </div>
            <div class="operate-wrap base-button">
                <div class="download-btn" @click="toDownload">
                    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="7 10 12 15 17 10" />
                        <line x1="12" y1="15" x2="12" y2="3" />
                    </svg>
                    <span class="download-text">下载应用</span>
                </div>
                <div class="login-btn" @click="openLogin">
                    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                        <polyline points="10 17 15 12 10 7" />
                        <line x1="15" x2="3" y1="12" y2="12" />
                    </svg>
                    <span>登录</span>
                </div>
            </div>
        </div>

        <!-- ======== 中间内容（产品介绍页） ======== -->
        <div class="know-wrap know-position">
            <div class="landing-content">
                <!-- Hero 主视觉 -->
                <section class="hero">
                    <div class="hero-left">
                        <div class="hero-tag-wrapper">
                            <div class="hero-tag">
                                <span class="sparkle">✨</span>
                                中小学AI学习助手
                            </div>
                            <div class="tech-arch-link" @click="openArchitecture">
                                <span class="tech-icon">⚙️</span>
                                探数蚁 · 技术架构
                            </div>
                        </div>
                        <h1>
                            让每一道题<br>
                            <span class="highlight">都变得生动有趣</span>
                            <span class="ant-emoji">🐜</span>
                        </h1>
                        <p>
                            探数蚁 —— 专为中小学生打造的AI学习伙伴。<br>
                            用<strong>动态图形</strong>讲透原理，用<strong>思维链</strong>拆解难题，用<strong>个性化推荐</strong>规划学习路径。<br>
                            让知识不再枯燥，让进步清晰可见。
                        </p>
                        <div class="hero-actions">
                            <button class="btn-hero btn-hero-primary" @click="scrollToSection('features')">
                                🚀 探索功能
                            </button>
                            <button class="btn-hero btn-hero-secondary" @click="openLogin">
                                💬 立即体验
                            </button>
                        </div>
                    </div>
                    <div class="hero-right">
                        <div class="hero-illustration">
                            <svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg" ref="fractalSvg">
                                <!-- 分形树由 JavaScript 绘制 -->
                            </svg>
                        </div>
                    </div>
                </section>

                <!-- 核心功能 -->
                <section class="section" id="features">
                    <div class="section-title">
                        <h2>
                            <span class="emoji">🔑</span>
                            <span class="gradient-text">&nbsp;核心能力</span>
                        </h2>
                        <p>专为中小学学习场景打造，让AI真正成为你的学习搭档</p>
                    </div>
                    
                    <!-- 学习路径体系图：桌面端水平 / 移动端垂直 -->
                    <div v-if="!isMobile" style="margin:0 auto 40px; max-width:1000px;">
                        <svg viewBox="0 0 1000 240" xmlns="http://www.w3.org/2000/svg" style="width:100%; height:auto; display:block;">
                            <defs>
                                <linearGradient id="nodeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" style="stop-color:#2e5bff;stop-opacity:1" />
                                <stop offset="100%" style="stop-color:#7c3aed;stop-opacity:1" />
                                </linearGradient>
                                <linearGradient id="nodeLight" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" style="stop-color:#eef3ff;stop-opacity:1" />
                                <stop offset="100%" style="stop-color:#dfe9ff;stop-opacity:1" />
                                </linearGradient>
                                <marker id="arrow" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="6" markerHeight="6" orient="auto">
                                <path d="M 0 0 L 10 5 L 0 10 z" fill="#2e5bff" />
                                </marker>
                                <marker id="arrowDash" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="6" markerHeight="6" orient="auto">
                                <path d="M 0 0 L 10 5 L 0 10 z" fill="#a855f7" />
                                </marker>
                            </defs>

                            <!-- 背景浅色装饰 -->
                            <rect x="0" y="0" width="1000" height="240" rx="24" fill="#f8faff" stroke="#edf2ff" stroke-width="1.5" />

                            <!-- 节点（从左到右） -->
                            <!-- 1. AI诊断 -->
                            <rect x="40" y="70" width="120" height="60" rx="16" fill="url(#nodeGrad)" />
                            <text x="100" y="102" text-anchor="middle" fill="#fff" font-size="16" font-weight="700" font-family="'PingFang SC','Microsoft YaHei',sans-serif">AI诊断</text>
                            <text x="100" y="120" text-anchor="middle" fill="#d0deff" font-size="11">精准定位薄弱点</text>

                            <!-- 2. 个性化推荐 -->
                            <rect x="240" y="70" width="120" height="60" rx="16" fill="url(#nodeGrad)" />
                            <text x="300" y="102" text-anchor="middle" fill="#fff" font-size="16" font-weight="700" font-family="'PingFang SC','Microsoft YaHei',sans-serif">个性推荐</text>
                            <text x="300" y="120" text-anchor="middle" fill="#d0deff" font-size="11">学习路径规划</text>

                            <!-- 3. 思维链拆题 / 一图胜千言 -->
                            <rect x="440" y="70" width="120" height="60" rx="16" fill="url(#nodeGrad)" />
                            <text x="500" y="102" text-anchor="middle" fill="#fff" font-size="16" font-weight="700" font-family="'PingFang SC','Microsoft YaHei',sans-serif">深度理解</text>
                            <text x="500" y="120" text-anchor="middle" fill="#d0deff" font-size="11">思维链 + 动态图形</text>

                            <!-- 4. 智能组卷 / 生成书 -->
                            <rect x="640" y="70" width="120" height="60" rx="16" fill="url(#nodeGrad)" />
                            <text x="700" y="102" text-anchor="middle" fill="#fff" font-size="16" font-weight="700" font-family="'PingFang SC','Microsoft YaHei',sans-serif">练习与输出</text>
                            <text x="700" y="120" text-anchor="middle" fill="#d0deff" font-size="11">组卷 · 生成书</text>

                            <!-- 5. 知识图谱 -->
                            <rect x="840" y="70" width="120" height="60" rx="16" fill="url(#nodeGrad)" />
                            <text x="900" y="102" text-anchor="middle" fill="#fff" font-size="16" font-weight="700" font-family="'PingFang SC','Microsoft YaHei',sans-serif">知识沉淀</text>
                            <text x="900" y="120" text-anchor="middle" fill="#d0deff" font-size="11">可视化知识图谱</text>

                            <!-- 箭头（实线） -->
                            <line x1="160" y1="100" x2="230" y2="100" stroke="#2e5bff" stroke-width="3" marker-end="url(#arrow)" />
                            <line x1="360" y1="100" x2="430" y2="100" stroke="#2e5bff" stroke-width="3" marker-end="url(#arrow)" />
                            <line x1="560" y1="100" x2="630" y2="100" stroke="#2e5bff" stroke-width="3" marker-end="url(#arrow)" />
                            <line x1="760" y1="100" x2="830" y2="100" stroke="#2e5bff" stroke-width="3" marker-end="url(#arrow)" />

                            <!-- 回环虚线（表示自适应反馈） -->
                            <path d="M 900 140 Q 900 180 500 180 Q 100 180 100 140" fill="none" stroke="#a855f7" stroke-width="2.5" stroke-dasharray="8 6" marker-end="url(#arrowDash)" />
                            <text x="500" y="210" text-anchor="middle" fill="#7c3aed" font-size="14" font-weight="600" font-family="'PingFang SC','Microsoft YaHei',sans-serif">🔄 自适应学习闭环 · 持续迭代</text>

                            <!-- 小标签 -->
                            <text x="100" y="45" text-anchor="middle" fill="#4b5e7a" font-size="12" font-weight="500">① 诊断</text>
                            <text x="300" y="45" text-anchor="middle" fill="#4b5e7a" font-size="12" font-weight="500">② 规划</text>
                            <text x="500" y="45" text-anchor="middle" fill="#4b5e7a" font-size="12" font-weight="500">③ 理解</text>
                            <text x="700" y="45" text-anchor="middle" fill="#4b5e7a" font-size="12" font-weight="500">④ 应用</text>
                            <text x="900" y="45" text-anchor="middle" fill="#4b5e7a" font-size="12" font-weight="500">⑤ 构建</text>
                        </svg>
                    </div>
                    <div v-else style="margin:0 auto 30px; max-width:1000px;">
                        <svg viewBox="0 0 500 400" xmlns="http://www.w3.org/2000/svg" style="width:100%; height:auto; display:block;">
                            <defs>
                                <!-- 节点渐变 -->
                                <linearGradient id="nodeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                                    <stop offset="0%" style="stop-color:#2e5bff;stop-opacity:1" />
                                    <stop offset="100%" style="stop-color:#7c3aed;stop-opacity:1" />
                                </linearGradient>

                                <!-- 实线箭头（蓝色） -->
                                <marker id="arrowBlue" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="6" markerHeight="6" orient="auto">
                                    <path d="M 0 0 L 10 5 L 0 10 z" fill="#2e5bff" />
                                </marker>

                                <!-- 虚线箭头（紫色） -->
                                <marker id="arrowPurple" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="6" markerHeight="6" orient="auto">
                                    <path d="M 0 0 L 10 5 L 0 10 z" fill="#a855f7" />
                                </marker>
                            </defs>

                            <!-- 外部虚线圆环（持续迭代） -->
                            <circle cx="250" cy="200" r="165" fill="none" stroke="#a855f7" stroke-width="2" stroke-dasharray="8 6" opacity="0.45" />

                            <!-- ========== 连接箭头（走外圈弧线） ========== -->
                            <!-- 1→2：顶部 → 右上 -->
                            <path d="M 305 93 Q 370 80 343 120" fill="none" stroke="#2e5bff" stroke-width="3" marker-end="url(#arrowBlue)" />
                            <!-- 2→3：右上 → 右下 -->
                            <path d="M 388 176 Q 420 235 340 280" fill="none" stroke="#2e5bff" stroke-width="3" marker-end="url(#arrowBlue)" />
                            <!-- 3→4：右下 → 左下 -->
                            <path d="M 280 308 Q 250 345 220 308" fill="none" stroke="#2e5bff" stroke-width="3" marker-end="url(#arrowBlue)" />
                            <!-- 4→5：左下 → 左上 -->
                            <path d="M 160 280 Q 80 235 112 176" fill="none" stroke="#2e5bff" stroke-width="3" marker-end="url(#arrowBlue)" />
                            <!-- 5→1：左上 → 顶部（紫色虚线，自适应反馈） -->
                            <path d="M 172 148 Q 130 80 195 93" fill="none" stroke="#a855f7" stroke-width="3" stroke-dasharray="6 4" marker-end="url(#arrowPurple)" />

                            <!-- ========== 五个节点 ========== -->
                            <!-- 1. AI诊断（顶部） -->
                            <rect x="190" y="65" width="120" height="56" rx="14" fill="url(#nodeGrad)" />
                            <text x="250" y="89" text-anchor="middle" fill="#fff" font-size="15" font-weight="700" font-family="'PingFang SC','Microsoft YaHei',sans-serif">AI诊断</text>
                            <text x="250" y="107" text-anchor="middle" fill="#d0deff" font-size="11" font-family="'PingFang SC','Microsoft YaHei',sans-serif">精准定位薄弱点</text>
                            <text x="250" y="55" text-anchor="middle" fill="#4b5e7a" font-size="12" font-weight="600" font-family="'PingFang SC','Microsoft YaHei',sans-serif">① 诊断</text>

                            <!-- 2. 个性推荐（右上） -->
                            <rect x="328" y="120" width="120" height="56" rx="14" fill="url(#nodeGrad)" />
                            <text x="388" y="144" text-anchor="middle" fill="#fff" font-size="15" font-weight="700" font-family="'PingFang SC','Microsoft YaHei',sans-serif">个性推荐</text>
                            <text x="388" y="162" text-anchor="middle" fill="#d0deff" font-size="11" font-family="'PingFang SC','Microsoft YaHei',sans-serif">学习路径规划</text>
                            <text x="388" y="110" text-anchor="middle" fill="#4b5e7a" font-size="12" font-weight="600" font-family="'PingFang SC','Microsoft YaHei',sans-serif">② 规划</text>

                            <!-- 3. 深度理解（右下） -->
                            <rect x="280" y="280" width="120" height="56" rx="14" fill="url(#nodeGrad)" />
                            <text x="340" y="304" text-anchor="middle" fill="#fff" font-size="15" font-weight="700" font-family="'PingFang SC','Microsoft YaHei',sans-serif">深度理解</text>
                            <text x="340" y="322" text-anchor="middle" fill="#d0deff" font-size="11" font-family="'PingFang SC','Microsoft YaHei',sans-serif">思维链 + 动态图形</text>
                            <text x="340" y="260" text-anchor="middle" fill="#4b5e7a" font-size="12" font-weight="600" font-family="'PingFang SC','Microsoft YaHei',sans-serif">③ 理解</text>

                            <!-- 4. 练习与输出（左下） -->
                            <rect x="100" y="280" width="120" height="56" rx="14" fill="url(#nodeGrad)" />
                            <text x="160" y="304" text-anchor="middle" fill="#fff" font-size="15" font-weight="700" font-family="'PingFang SC','Microsoft YaHei',sans-serif">练习与输出</text>
                            <text x="160" y="322" text-anchor="middle" fill="#d0deff" font-size="11" font-family="'PingFang SC','Microsoft YaHei',sans-serif">组卷 · 生成书</text>
                            <text x="160" y="270" text-anchor="middle" fill="#4b5e7a" font-size="12" font-weight="600" font-family="'PingFang SC','Microsoft YaHei',sans-serif">④ 应用</text>

                            <!-- 5. 知识沉淀（左上） -->
                            <rect x="52" y="120" width="120" height="56" rx="14" fill="url(#nodeGrad)" />
                            <text x="112" y="144" text-anchor="middle" fill="#fff" font-size="15" font-weight="700" font-family="'PingFang SC','Microsoft YaHei',sans-serif">知识沉淀</text>
                            <text x="112" y="162" text-anchor="middle" fill="#d0deff" font-size="11" font-family="'PingFang SC','Microsoft YaHei',sans-serif">可视化知识图谱</text>
                            <text x="112" y="110" text-anchor="middle" fill="#4b5e7a" font-size="12" font-weight="600" font-family="'PingFang SC','Microsoft YaHei',sans-serif">⑤ 构建</text>

                            <!-- ========== 中心圆环 ========== -->
                            <circle cx="250" cy="200" r="50" fill="#ffffff" stroke="#2e5bff" stroke-width="2" />
                            <circle cx="250" cy="200" r="40" fill="#eef3ff" stroke="#2e5bff" stroke-width="1.5" stroke-dasharray="4 4" />
                            
                            <!-- 中心文字 -->
                            <text x="250" y="177" text-anchor="middle" font-size="16" font-family="'PingFang SC','Microsoft YaHei',sans-serif">🔄</text>
                            <text x="250" y="197" text-anchor="middle" fill="#2e5bff" font-size="12" font-weight="700" font-family="'PingFang SC','Microsoft YaHei',sans-serif">自适应</text>
                            <text x="250" y="215" text-anchor="middle" fill="#2e5bff" font-size="12" font-weight="700" font-family="'PingFang SC','Microsoft YaHei',sans-serif">学习闭环</text>

                            <!-- 底部说明 -->
                            <text x="250" y="385" text-anchor="middle" fill="#7c3aed" font-size="13" font-weight="600" font-family="'PingFang SC','Microsoft YaHei',sans-serif">🔄 自适应反馈 · 持续迭代</text>
                        </svg>
                    </div>

                    
                    <div class="features-grid">
                        <div class="feature-card">
                            <div class="feature-icon">📈</div>
                            <h3>一图胜千言</h3>
                            <p>用 <strong>图像/动图/动画/课件</strong> 演示知识核心，让抽象概念<strong>「动」</strong>起来，让动态过程自己<strong>「说」</strong>出规律。</p>
                            <span class="tag-new">新 · 3D图形</span>
                        </div>
                        <div class="feature-card">
                            <div class="feature-icon">📸</div>
                            <h3>拍照解题</h3>
                            <p>一拍即解，秒出思路。支持手写题、打印题、复杂几何图，自动识别并给出<strong>详尽推理过程</strong>，让难题无所遁形。</p>
                            <span class="tag-new">新 · AI识图</span>
                        </div>
                        <div class="feature-card">
                            <div class="feature-icon">⛓️</div>
                            <h3>思维链拆题</h3>
                            <p>融合<strong>波利亚解题模型</strong>、<strong>逆向链</strong>、<strong>类比链</strong>等11种思维策略，不止给答案，更带你亲历思考全过程。</p>
                        </div>
                        <div class="feature-card">
                            <div class="feature-icon">🔍</div>
                            <h3>AI实时诊断</h3>
                            <p>通过<strong>智能诊断测试</strong>，精准定位知识薄弱环节，生成详细的<strong>诊断分析报告</strong>，并为你规划<strong>最优学习路径</strong>，让提升更有方向。</p>
                            <span class="tag-new">新 · 智能诊断</span>
                        </div>
                        <div class="feature-card">
                            <div class="feature-icon">🎯</div>
                            <h3>个性化推荐</h3>
                            <p>根据你的年级、学习数据和薄弱环节，智能推荐<strong>主题任务</strong>、<strong>专题突破</strong>、<strong>知识图谱</strong>和<strong>练习题</strong>，精准提升。</p>
                        </div>
                        <div class="feature-card">
                            <div class="feature-icon">🏔</div>
                            <h3>智能路径规划</h3>
                            <p>根据你的薄弱点，动态推荐 <strong>「基础 → 提升 → 挑战」</strong> 阶梯式学习路线，拒绝盲目刷题，每一步都踩在关键点上。</p>
                            <span class="tag-hot">热门 · 自适应</span>
                        </div>
                        <div class="feature-card">
                            <div class="feature-icon">⚖️</div>
                            <h3>智能组卷</h3>
                            <p>
                                <strong>错题组卷</strong> · 基于你的错题本自动生成针对性试卷；<br>
                                <strong>真题组卷</strong> · 整合历年中考/高考真题，一键生成仿真试卷。
                            </p>
                            <span class="tag-ai">新 · 多模组卷</span>
                        </div>
                        <div class="feature-card">
                            <div class="feature-icon">📚</div>
                            <h3>一键生成书</h3>
                            <p>
                                生成你想要的<strong>知识手册</strong>、<strong>备考指南</strong>、
                                <strong>学科小说</strong> 或 <strong>趣味绘本</strong>。
                                AI实时记录阅读轨迹，让每一份努力都变成可翻阅的成长之书。
                            </p>
                            <span class="tag-ai">新 · AI创作</span>
                        </div>
                        <div class="feature-card">
                        <div class="feature-icon">🕸️</div>
                        <h3>知识图谱</h3>
                        <p>
                            <strong>一句话</strong>即可将任何内容转化为知识图谱，通过可视化关联图谱，
                            帮你<strong>系统学习</strong>，理清知识脉络，构建完整知识体系。
                        </p>
                        <span class="tag-new">新 · AI生成</span>
                        </div>
                    </div>
                </section>

                <!-- 为什么选择探数蚁 · 四选项卡 -->
                <div class="features-alt" id="advantages">
                    <div class="section-title">
                        <h2>
                            <span class="emoji">✨</span>
                            <span class="gradient-text">&nbsp;为什么选择探数蚁？</span>
                        </h2>
                        <p>不止是工具，更是陪伴你成长的智能学伴</p>
                    </div>

                    <div class="tabs-nav" role="tablist">
                        <!-- 新增“关于我们”标签 -->
                        <button class="tab-btn" :class="{ active: activeTab === 'tab0' }" @click="activeTab = 'tab0'" role="tab" :aria-selected="activeTab === 'tab0'">
                            <span class="tab-icon">📖</span> 关于我们
                        </button>
                        <button class="tab-btn" :class="{ active: activeTab === 'tab1' }" @click="activeTab = 'tab1'" role="tab" :aria-selected="activeTab === 'tab1'">
                            <span class="tab-icon">🔒</span> 安全与隐私
                        </button>
                        <button class="tab-btn" :class="{ active: activeTab === 'tab2' }" @click="activeTab = 'tab2'" role="tab" :aria-selected="activeTab === 'tab2'">
                            <span class="tab-icon">🎯</span> 专业与专注
                        </button>
                        <button class="tab-btn" :class="{ active: activeTab === 'tab3' }" @click="activeTab = 'tab3'" role="tab" :aria-selected="activeTab === 'tab3'">
                            <span class="tab-icon">📚</span> 持续更新与优化
                        </button>
                        <button class="tab-btn" :class="{ active: activeTab === 'tab4' }" @click="activeTab = 'tab4'" role="tab" :aria-selected="activeTab === 'tab4'">
                            <span class="tab-icon">💬</span> 用户反馈
                        </button>
                    </div>

                    <div class="tabs-content">
                        <!-- Tab 0: 关于我们 -->
                        <div class="tab-panel" :class="{ active: activeTab === 'tab0' }" role="tabpanel">
                            <div class="panel-inner">
                                <div class="panel-head">
                                    <div class="big-icon">📖</div>
                                    <h3>关于 <span class="accent">我们</span></h3>
                                </div>
                                <div class="panel-body">
                                    <p>
                                        <strong>探数蚁团队</strong>汇聚清华博士、中学特级教师、中国数学奥林匹克一级教练员与一线授课教师，
                                        依托博士团队的AI智能体技术研发能力，结合资深教师多年实战教学经验，打造智能化数理学习方案，
                                        专注培养学生数学思维。
                                    </p>
                                    <div class="contact-links-vertical">
                                        <div class="link-item" @click="openPrivatePolicy">服务条款</div>
                                        <div class="link-item" @click="openServiceItem">隐私政策</div>
                                        <div class="link-item contact-email">联系我们 ✏️ tanyi@tanyi.cc</div>
                                    </div>
                                    <div class="qr-code-wrapper">
                                        <!-- 左侧：联系二维码 -->
                                        <div class="qr-code-block">
                                            <img src="@/assets/image/ct.png" alt="联系二维码" class="qr-code-large">
                                            <span class="qr-tip-text">扫码联系</span>
                                        </div>
                                        <!-- 右侧：App下载二维码 -->
                                        <div class="qr-code-block qr-code-download">
                                            <img src="/app/apk.png" alt="下载App二维码" class="qr-code-large">
                                            <div class="qr-download-links">
                                                <span class="qr-tip-text">安卓App</span>
                                                <span class="sep">|</span>
                                                <a href="/app/tanshuyi.apk" class="qr-tip-text download-link">点击下载</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Tab 1：安全与隐私 -->
                        <div class="tab-panel" :class="{ active: activeTab === 'tab1' }" role="tabpanel">
                            <div class="panel-inner">
                                <div class="panel-head">
                                    <div class="big-icon">🔒</div>
                                    <h3>安全与 <span class="accent">隐私</span></h3>
                                </div>
                                <div class="panel-body">
                                    <p><strong>探数蚁</strong> 严格遵守数据安全规范，<span class="highlight-text">不会泄露您的个人信息或对话记录</span>。所有教学互动内容仅用于学习辅助，<span class="highlight-purple">不涉及任何商业滥用</span>。</p>
                                    <p>我们深知，信任是学习的基石。因此，从数据加密到权限管控，每一个环节都经过精心设计，确保你的学习数据只属于你自己。</p>
                                    <div class="tag-group">
                                        <span class="mini-tag"><span class="emoji">🛡️</span> 数据加密</span>
                                        <span class="mini-tag"><span class="emoji">🔐</span> 隐私保护</span>
                                        <span class="mini-tag"><span class="emoji">✅</span> 前置验证</span>
                                        <span class="mini-tag"><span class="emoji">📋</span> 合规透明</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Tab 2：专业与专注 -->
                        <div class="tab-panel" :class="{ active: activeTab === 'tab2' }" role="tabpanel">
                            <div class="panel-inner">
                                <div class="panel-head">
                                    <div class="big-icon">🎯</div>
                                    <h3>专业与 <span class="accent">专注</span></h3>
                                </div>
                                <div class="panel-body">
                                    <p>我们专注于 <strong>中小学教育领域</strong>，覆盖 <span class="highlight-text">数学、物理、化学、语文、英语</span> 等多学科，深度贴合各学科的知识体系与思维特点。</p>
                                    <p>拥有 <span class="highlight-purple">多模态交互能力</span>（文字、图形、动画、流程图等），让抽象知识变得 <strong>直观易懂</strong>。内置 <strong>思维链</strong>、<strong>波利亚解题模型</strong> 等高级推理框架，帮助你 <span class="highlight-text">真正理解解题思路</span>，而非死记硬背。</p>
                                    <div class="tag-group">
                                        <span class="mini-tag"><span class="emoji">📐</span> 数学</span>
                                        <span class="mini-tag"><span class="emoji">⚛️</span> 物理</span>
                                        <span class="mini-tag"><span class="emoji">🧪</span> 化学</span>
                                        <span class="mini-tag"><span class="emoji">🧩</span> MECE分类</span>
                                        <span class="mini-tag"><span class="emoji">📊</span> 多模态输出</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Tab 3：持续更新与优化 -->
                        <div class="tab-panel" :class="{ active: activeTab === 'tab3' }" role="tabpanel">
                            <div class="panel-inner">
                                <div class="panel-head">
                                    <div class="big-icon">📚</div>
                                    <h3>持续更新与 <span class="accent">优化</span></h3>
                                </div>
                                <div class="panel-body">
                                    <p><strong>题库、知识点、互动功能</strong> 会持续更新，紧跟 <span class="highlight-text">教学大纲</span> 和 <span class="highlight-text">考试趋势</span>，确保你学到的始终是最新、最实用的内容。</p>
                                    <p>系统会根据你的 <strong>年级</strong> 和 <strong>学习情况</strong>，智能推荐 <span class="highlight-purple">个性化练习</span>、<span class="highlight-purple">主题任务</span>、<span class="highlight-purple">学习路径规划</span> 等，真正做到 <strong>因材施教</strong>，让每一份努力都精准有效。</p>
                                    <div class="tag-group">
                                        <span class="mini-tag"><span class="emoji">📝</span> 题库2万+</span>
                                        <span class="mini-tag"><span class="emoji">🔄</span> PDCA闭环</span>
                                        <span class="mini-tag"><span class="emoji">📈</span> 教材同步</span>
                                        <span class="mini-tag"><span class="emoji">🧠</span> 个性化推荐</span>
                                        <span class="mini-tag"><span class="emoji">🗺️</span> 路径规划</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Tab 4：用户反馈 -->
                        <div class="tab-panel" :class="{ active: activeTab === 'tab4' }" role="tabpanel">
                            <div class="panel-inner">
                                <div class="panel-head">
                                    <div class="big-icon">💬</div>
                                    <h3>用户 <span class="accent">反馈</span></h3>
                                </div>
                                <div class="panel-body">
                                    <div class="quote-block">
                                        "探数蚁的 <strong>画图 + 动画 + 思维链</strong> 组合方式，让难题变得 <span class="highlight-text">容易理解</span>，以前看不懂的几何题，现在一看图就明白了！"
                                        <span class="quote-source">—— 初三 · 李同学</span>
                                    </div>
                                    <div class="quote-block" style="border-left-color: #2e5bff; background: #f0f6ff;">
                                        "使用探数蚁一个月，数学从及格线提升到了班里前十。最喜欢它的 <strong>思维链拆题</strong>，每一步都讲得很清楚。"
                                        <span class="quote-source">—— 高一 · 王同学</span>
                                    </div>
                                    <div class="quote-block" style="border-left-color: #10b981; background: #ecfdf5;">
                                        "我每天最期待的就是追读探数蚁里的 <strong>数学奇遇记小说</strong>，故事里的探险情节让我在轻松愉快的氛围中学会了 <span class="highlight-text">比例、方程和几何</span> 知识，现在上数学课都更有信心了！"
                                        <span class="quote-source">—— 六年级 · 小张</span>
                                    </div>
                                    <p style="margin-top: 16px;">团队的宗旨是 <strong>"让学习不再枯燥，让思考更有深度"</strong>。每一个反馈都是我们前进的动力，每一次迭代都为了让你遇见更好的自己。</p>
                                    <div class="tag-group">
                                        <span class="mini-tag"><span class="emoji">⭐</span> 好评如潮</span>
                                        <span class="mini-tag"><span class="emoji">🤝</span> 互动式学习</span>
                                        <span class="mini-tag"><span class="emoji">🎓</span> 学有所成</span>
                                        <span class="mini-tag"><span class="emoji">❤️</span> 用心陪伴</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ===== 版权信息（直接写在页面底部） ===== -->
                <div class="page-bottom-copyright">
                    <span>版权所有©东莞市探蚁人工智能科技有限公司</span>
                    <span class="sep">|</span>
                    <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noreferrer">
                        粤ICP备2026011271号-1
                    </a>
                </div>
            </div>
        </div>

        <!-- ======== 登录面板 ======== -->
        <div id="page_layout" class="layout-new hide-scrollbar" :class="!isInit ? 'panel-show' : ''">
            <div class="container login">
                <div class="left-banner" data-monitor-comp-topic="auth_banner">
                    <div class="hotspot" style="cursor: pointer;"><img
                            src="https://res.volccdn.com/obj/volc-console-fe/vconsole-static/auth.ydl_banner.97198265.png">
                    </div>
                </div>
                <div>
                    <div class="arco-spin layout-spin">
                        <div class="arco-spin-children">
                            <div class="login-card card-has-tab" v-show="isLogin">
                                <div class="title">欢迎来到探数蚁</div>
                                <div class="arco-tabs  account-tab">
                                    <div class="arco-tabs-header" style="transform: translateX(0PX);">
                                        <div class="arco-tabs-header-title"
                                            :class="activeName === 'codeLoginForm' ? 'active' : ''" aria-selected="true"
                                            tabindex="0" aria-controls="arco-tabs-10-panel-0"><span class="tabs-text"
                                                :disabled="isLoading" @click="handleClick('codeLoginForm')">手机号登录</span>
                                            <div class="header-ink"></div>
                                        </div>
                                        <div class="arco-tabs-header-title"
                                            :class="activeName === 'pwdLoginForm' ? 'active' : ''" aria-selected="false"
                                            tabindex="0" aria-controls="arco-tabs-10-panel-1">
                                            <span class="tabs-text" :disabled="isLoading"
                                                @click="handleClick('pwdLoginForm')">账号登录</span>
                                            <div class="header-ink"></div>
                                        </div>
                                        <div class="arco-tabs-header-title"
                                            :class="activeName === 'registerForm' ? 'active' : ''" aria-selected="false"
                                            tabindex="0" aria-controls="arco-tabs-10-panel-1">
                                            <span class="tabs-text" :disabled="isLoading"
                                                @click="handleClick('registerForm')">注册</span>
                                            <div class="header-ink"></div>
                                        </div>
                                    </div>

                                    <el-form :model="codeLoginForm" :rules="codeLoginRules" ref="codeLoginForm"
                                        v-show="activeName === 'codeLoginForm'" class="demo-ruleForm with-puzzle">
                                        <el-form-item class="verify_item" prop="phoneNumber">
                                            <el-input v-model="codeLoginForm.phoneNumber" autocomplete="off"
                                                placeholder="手机号码"></el-input>
                                            <span class="verifycode-btn code-btn-able" v-if="codeLoginForm_count === 60"
                                                :class="codeFormBtnClass"
                                                @click.prevent="sendSmsCode('codeLoginForm')">获取验证码</span>
                                            <span v-else class="verifycode-btn code-btn-disabled">{{
                                                `${codeLoginForm_count}秒后重试`
                                                }}</span>
                                        </el-form-item>
                                        <el-form-item class="verify_item" prop="code">
                                            <el-input v-model="codeLoginForm.code" autocomplete="off"
                                                placeholder="短信验证码"></el-input>
                                        </el-form-item>
                                        <el-form-item class="operate-item">
                                            <div class="protocol">登录视为您已阅读并同意探数蚁<a
                                                    @click.default="openServiceItem">服务条款</a>和<a
                                                    @click.default="openPrivatePolicy" target="_blank">隐私政策</a>
                                            </div>

                                            <div class="auto-register-tip">
                                            <span class="highlight-text">未注册手机号将自动注册</span>，可<a @click.prevent="toResetPwd" class="reset-pwd-link">重置密码</a>使用账号登录
                                            </div>

                                            <el-button type="primary" :disabled="isLoading"
                                                @click="submitForm('codeLoginForm')">登录</el-button>
                                            <el-button class="close-btn" :disabled="isLoading"
                                                @click="isInit = true">关闭</el-button>
                                        </el-form-item>
                                    </el-form>
                                    <el-form :model="pwdLoginForm" :rules="pwdLoginRules" ref="pwdLoginForm"
                                        v-show="activeName === 'pwdLoginForm'" class="demo-ruleForm with-puzzle">
                                        <el-form-item prop="phoneNumber">
                                            <el-input v-model="pwdLoginForm.phoneNumber" autocomplete="off"
                                                placeholder="手机号码"></el-input>
                                        </el-form-item>
                                        <el-form-item prop="password">
                                            <el-input type="password" v-model="pwdLoginForm.password" autocomplete="off"
                                                placeholder="用户密码" show-password></el-input>
                                        </el-form-item>
                                        <el-form-item class="operate-item">
                                            <div class="protocol">登录视为您已阅读并同意探数蚁<a
                                                    @click.default="openServiceItem">服务条款</a>和<a
                                                    @click.default="openPrivatePolicy">隐私政策</a></div>
                                            <el-button type="primary" :disabled="isLoading"
                                                @click="submitForm('pwdLoginForm')">登录</el-button>
                                            <el-button class="close-btn" :disabled="isLoading"
                                                @click="isInit = true">关闭</el-button>
                                        </el-form-item>
                                        <el-form-item>
                                            <div class="link-wrap" v-show="activeName === 'pwdLoginForm'"><span
                                                    class="forget-pwd">
                                                    <el-checkbox label="记住我" v-model="pwdLoginForm.remberme"
                                                        name="remberme">记住密码</el-checkbox><a class="text"
                                                        @click.prevent="toResetPwd">忘记密码？</a></span>
                                            </div>
                                            <div class="suffix-node">没有账号？ <a @click="toRegister"><span
                                                        style="font-weight: 500;">现在就注册</span></a>
                                            </div>
                                        </el-form-item>
                                    </el-form>
                                </div>
                            </div>
                            <div class="login-card card-has-tab" v-show="isRegister">
                                <div class="title register-title">注 册 账 号</div>
                                <el-form :model="registerForm" :rules="registerRules" ref="registerForm"
                                    class="demo-ruleForm without-validcode">
                                    <el-form-item prop="phoneNumber" class="verify_item">
                                        <el-input v-model="registerForm.phoneNumber" autocomplete="off"
                                            placeholder="手机号码"></el-input>
                                        <span class="verifycode-btn code-btn-able" v-if="registerForm_count === 60"
                                            :class="registerFormBtnClass"
                                            @click.prevent="sendSmsCode('registerForm')">获取验证码</span>
                                        <span v-else class="verifycode-btn code-btn-disabled">{{
                                            `${registerForm_count}秒后重试`
                                            }}</span>
                                    </el-form-item>
                                    <el-form-item class="verify_item" prop="code">
                                        <el-input v-model="registerForm.code" autocomplete="off"
                                            placeholder="短信验证码"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="password" class="validPassword-item">
                                        <el-input type="password" v-model="registerForm.password"
                                            autocomplete="new-password" placeholder="密码：长度8-16位，须含字母和数字" show-password></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="
                                        registerForm.password !== '' &&
                                        registerForm.password !== undefined
                                    " class="strength-item">
                                        <valid-strength :password="registerForm.password" />
                                    </el-form-item>
                                    <el-form-item prop="confirmPassword">
                                        <el-input type="password" v-model="registerForm.confirmPassword"
                                            autocomplete="off" placeholder="确认密码" show-password></el-input>
                                    </el-form-item>

                                    <el-form-item class="operate-item register">
                                        <div class="protocol">登录视为您已阅读并同意探数蚁<a
                                                @click.default="openServiceItem">服务条款</a>和<a
                                                @click.default="openPrivatePolicy">隐私政策</a>
                                        </div>

                                        <el-button type="primary" :disabled="isLoading"
                                            @click="submitForm('registerForm')">注册</el-button>
                                        <el-button class="close-btn" :disabled="isLoading"
                                            @click="isInit = true">关闭</el-button>
                                    </el-form-item>
                                </el-form>
                                <div class="suffix-node">已有账号？ <a @click="toLogin"><span
                                            style="font-weight: 500;">立即登录</span></a></div>
                            </div>

                            <div class="forget-card card-has-tab" v-show="isForget">
                                <div class="title register-title">重 置 密 码</div>
                                <el-form :model="forgetForm" :rules="forgetRules" ref="forgetForm"
                                    class="demo-ruleForm without-validcode">
                                    <el-form-item prop="phoneNumber" class="verify_item">
                                        <el-input v-model="forgetForm.phoneNumber" autocomplete="off"
                                            placeholder="手机号码"></el-input>
                                        <span class="verifycode-btn code-btn-able" v-if="forgetForm_count === 60"
                                            :class="registerFormBtnClass"
                                            @click.prevent="sendSmsCode('forgetForm')">获取验证码</span>
                                        <span v-else class="verifycode-btn code-btn-disabled">{{
                                            `${forgetForm_count}秒后重试`
                                            }}</span>
                                    </el-form-item>
                                    <el-form-item class="verify_item" prop="code">
                                        <el-input v-model="forgetForm.code" autocomplete="off"
                                            placeholder="短信验证码"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="password" class="validPassword-item">
                                        <el-input type="password" v-model="forgetForm.newPassword"
                                            autocomplete="new-password" placeholder="密码：长度8-16位，须含字母和数字" show-password></el-input>
                                    </el-form-item>
                                    <el-form-item v-if="
                                        forgetForm.newPassword !== '' &&
                                        forgetForm.newPassword !== undefined
                                    " class="strength-item">
                                        <valid-strength :password="forgetForm.newPassword" />
                                    </el-form-item>
                                    <el-form-item prop="confirmPassword">
                                        <el-input type="password" v-model="forgetForm.confirmPassword"
                                            autocomplete="off" placeholder="确认密码" show-password></el-input>
                                    </el-form-item>

                                    <el-form-item class="operate-item register">
                                        <div class="protocol">登录视为您已阅读并同意探数蚁<a
                                                @click.default="openServiceItem">服务条款</a>和<a
                                                @click.default="openPrivatePolicy">隐私政策</a></div>

                                        <el-button type="primary" :disabled="isLoading"
                                            @click="submitForm('forgetForm')">确定</el-button>
                                        <el-button class="close-btn" :disabled="isLoading"
                                            @click="isInit = true">关闭</el-button>
                                    </el-form-item>
                                </el-form>
                                <div class="suffix-node"> <a @click="toLogin"><span
                                            style="font-weight: 500;">立即登录</span></a></div>
                            </div>
                            <div class="password-expiration-box"></div>
                        </div>
                    </div>
                </div>
            </div>
            <Vcode :show="isPuzzle" @success="onSuccess" @close="onClose" />
        </div>

        <!-- ======== 没有单独的 footer 标签 ======== -->
    </div>
</template>

<script>
import store from "@/store";
import axios from "axios";
import { debounce } from 'lodash';
import validCode from "@/components/login/validCode";
import validStrength from "@/components/login/validStrength";
import Vcode from "vue-puzzle-vcode";
import { level, checkPasswordRule } from "@/utils/checkPassword";
import { encrypt, decrypt } from "@/utils/jsencrypt";
import { getPrivatePolicy, getServiceItems, getArchitecture } from "@/api/login/index"
import * as loginApi from "@/api/login";
import { mapState } from "vuex/dist/vuex.common.js";
import { isElectronEnv } from "@/utils/tool"

export default {
    name: "login",
    components: {
        validCode,
        validStrength,
        Vcode
    },
    data() {
        var checkphoneNumber = (rule, value, callback) => {
            if (value === "") {
                return callback(new Error("手机号码不能为空"));
            } else {
                let phone = /^1[3-9]\d{9}$/;
                if (!phone.test(value)) {
                    return callback(new Error("请输入手机号码"));
                } else {
                    callback();
                }
            }
        };
        var checkLoginPassword = (rule, value, callback) => {
            if (value === "" || value.length < 8 || value.length > 32) {
                return callback(new Error("密码长度应大于8小于32"));
            } else {
                callback();
            }
        };
        var checkNewPassword = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码，长度8-16位，须含字母和数字"));
            } else {
                let name = "";
                if (this.registerForm.phoneNumber === "") {
                    name = "空";
                } else {
                    name = this.registerForm.phoneNumber;
                }
                const result = checkPasswordRule(value, name);
                if (result === "校验通过") {
                    callback();
                } else {
                    callback(new Error(result));
                }
            }
        };
        var checkConfirmPassword = (rule, value, callback) => {
            this.$refs.registerForm.validateField("password", (err) => { });
            if (value === "") {
                return callback(new Error("请再次输入密码"));
            } else if (value !== this.registerForm.password) {
                return callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };

        var checkForgetNewPassword = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                let name = "";
                if (this.forgetForm.phoneNumber === "") {
                    name = "空";
                } else {
                    name = this.forgetForm.phoneNumber;
                }
                const result = checkPasswordRule(value, name);
                if (result === "校验通过") {
                    callback();
                } else {
                    callback(new Error(result));
                }
            }
        };
        var checkForgetConfirmPassword = (rule, value, callback) => {
            this.$refs.forgetForm.validateField("newPassword", (err) => { });
            if (value === "") {
                return callback(new Error("请再次输入密码"));
            } else if (value !== this.forgetForm.newPassword) {
                return callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        var checkPwdValidCode = (rule, value, callback) => {
            if (!value || value.trim() === "") {
                return callback(new Error("请输入验证码"));
            } else if (value !== this.pwdLoginForm_code) {
                return callback(new Error("验证码不正确"));
            } else {
                callback();
            }
        };
        var checkCode = (rule, value, callback) => {
            const reg = /^\d{4}$/;
            if (!value || value.trim() === "") {
                return callback(new Error("请输入短信验证码"));
            } else if (!reg.test(value)) {
                return callback(new Error("短信验证码格式不正确"));
            } else {
                callback();
            }
        };
        return {
            isPuzzle: false,
            tips: "拖动左边滑块完成上方拼图",
            msg: "",
            dataOption: {

            },
            cancelToken: null,
            graphicLoading: true,
            isInit: true,
            codeLoginForm_send: false,
            registerForm_send: false,
            validMsg: "",
            isLogin: true,
            isLoading: false,
            isForget: false,
            isRegister: false,
            sliderValid: false,
            activeName: "codeLoginForm",
            pwdLoginForm_code: "",
            codeLoginForm_code: "",
            registerForm_code: "",
            isShow: false,
            codeLoginForm_timer: null,
            registerForm_timer: null,
            forgetForm_timer: null,
            codeLoginForm_count: 60,
            registerForm_count: 60,
            forgetForm_count: 60,
            puzzleImges: [],
            pwdLoginForm: {
                phoneNumber: "",
                password: "",
                validCode: "",
                remberme: [],
            },
            codeLoginForm: {
                phoneNumber: "",
                sliderValid: 0,
                code: "",
            },
            registerForm: {
                phoneNumber: "",
                password: "",
                confirmPassword: "",
                code: "",
            },

            forgetForm: {
                phoneNumber: "",
                newPassword: "",
                confirmPassword: "",
                code: "",
            },
            pwdLoginRules: {
                phoneNumber: [{ validator: checkphoneNumber, trigger: "blur" }],
                password: [{ validator: checkLoginPassword, trigger: "blur" }],
                validCode: [{ validator: checkPwdValidCode, trigger: "blur" }],
            },
            codeLoginRules: {
                phoneNumber: [{ validator: checkphoneNumber, trigger: "blur" }],
                code: [{ validator: checkCode, trigger: "blur" }],
            },
            registerRules: {
                phoneNumber: [{ validator: checkphoneNumber, trigger: "blur" }],
                password: [{ validator: checkNewPassword, trigger: "blur" }],
                confirmPassword: [{ validator: checkConfirmPassword, trigger: "blur" }],
                code: [{ validator: checkCode, trigger: "blur" }],
            },
            forgetRules: {
                phoneNumber: [{ validator: checkphoneNumber, trigger: "blur" }],
                newPassword: [{ validator: checkForgetNewPassword, trigger: "blur" }],
                confirmPassword: [{ validator: checkForgetConfirmPassword, trigger: "blur" }],
                code: [{ validator: checkCode, trigger: "blur" }],
            },
            activeTab: 'tab0',  // 默认激活“关于我们”
            cardObserver: null, // 用于移动端卡片滚动监听
        };
    },
    mounted() {
        this.initFractalTree();
        this.$nextTick(() => {
            this.observeCards();
        });
    },
    created() {
        this.debounceCheck = debounce(this.checkIsLogined, 500);
        this.debounceCheck();
        this.getUser();
        this.getImageUrl();
    },


    activated() {
        console.log("activated");
        this.debounceCheck();
        this.sliderValid = false;
    },
    computed: {
        codeFormBtnClass() {
            return this.codeLoginForm_count > 60 ? "" : "disabled";
        },
        registerFormBtnClass() {
            return this.registerForm_count > 60 ? "" : "disabled";
        },
        ...mapState(["isMobile"])

    },
    beforeDestroy() {
        if (this.codeLoginForm_timer)
            clearInterval(this.codeLoginForm_timer);
        if (this.registerForm_timer)
            clearInterval(this.registerForm_timer);
        if (this.cancelToken) {
            this.cancelToken.cancel('请求被取消');
        }
        if (this.fractalAnimId) cancelAnimationFrame(this.fractalAnimId);
        if (this.cardObserver) {
            this.cardObserver.disconnect();
            this.cardObserver = null;
        }
    },
    methods: {
        async openArchitecture() {
            const newWindow = window.open('', '_blank');
            let res = await getArchitecture();
            if (!res) return;
            newWindow.document.write(res.data);
            newWindow.document.close();
        },
        scrollToSection(id) {
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },
        openLogin() {
            this.isInit = false;
        },
        isShowDownload() {
            return !isElectronEnv()
        },
        async checkIsLogined() {
            if (!store.state || !store.state.token || store.state.token === "") return
            try {
                const source = axios.CancelToken.source();
                this.cancelToken = source;

                const res = await loginApi.checkIsLogined({
                    cancelToken: source.token
                });

                if (res && res.status === 200) {
                    this.$router.push("/chatSearch/exercises")
                    return
                }

            } catch (error) {
                if (axios.isCancel(error)) {
                    console.log('请求被取消:', error.message);
                } else {
                    console.error('请求失败:', error);
                }
            }

        },
        toLogin() {
            if (this.isForget && this.forgetForm.phoneNumber && !this.pwdLoginForm.password) {
                this.pwdLoginForm.phoneNumber = this.forgetForm.phoneNumber;
                this.pwdLoginForm.password = '';
            } 
            else if (this.isRegister && this.registerForm.phoneNumber && !this.pwdLoginForm.password) {
                this.pwdLoginForm.phoneNumber = this.registerForm.phoneNumber;
                this.pwdLoginForm.password = '';
            }
            this.isRegister = false;
            this.isForget = false;
            this.isLogin = true;
            this.activeName = 'pwdLoginForm';
        },

        toDownload() {
            this.$router.push("/downloadDesk")
        },

        getImageUrl(n) {
            this.puzzleImges = new Array(37).fill(0).map((item, index) => {
                return require(`@/assets/image/puzzle/puzzle_${index + 1}.png`);
            });
        },
        verify(result) {
            this.sliderValid = result;
            console.log(result);
        },
        async onSuccess() {
            this.sliderValid = true;
            this.isPuzzle = false;
            this.msg = "验证成功";

            if (this.isLogin && this.activeName === 'pwdLoginForm') {
                if (this.pwdLoginForm.remberme) {
                    this.encryptUserInfo(this.pwdLoginForm.phoneNumber, this.pwdLoginForm.password);
                } else {
                    localStorage.removeItem("u");
                }

                this.isLoading = true;
                try {
                    const res = await loginApi.loginByPassword(this.pwdLoginForm);
                    if (res && (res.status === 200 || res.status === 201)) {
                        store.commit("setToken", res.data.token);
                        store.commit("setUser", { phoneNumber: this.pwdLoginForm.phoneNumber });
                        this.$message.success("登录成功");
                        this.$router.push({ path: "/chatSearch/exercises" });
                    } else {
                        const errorMsg = res?.data?.message || '登录失败，请检查账号或密码';
                        this.$message.error(errorMsg);
                    }
                } catch (error) {
                    console.error('登录请求异常:', error);
                    this.$message.error('登录失败，请稍后重试');
                } finally {
                    this.isLoading = false;
                    this.sliderValid = false;
                    this.$nextTick(() => {
                        this.isPuzzle = false;
                    });
                }
            }
            else if (this.isRegister) {
                this.isLoading = true;
                try {
                    const res = await loginApi.registerUser(this.registerForm);
                    if (res && (res.status === 200 || res.status === 201)) {
                        this.$message.success("注册成功, 请登录");

                        if (this.registerForm_timer) {
                            clearInterval(this.registerForm_timer);
                            this.registerForm_timer = null;
                        }
                        this.registerForm_count = 60;

                        this.activeName = 'pwdLoginForm';

                        this.$nextTick(() => {
                            this.pwdLoginForm.phoneNumber = this.registerForm.phoneNumber;
                            this.pwdLoginForm.password = this.registerForm.password;

                            if (this.$refs.pwdLoginForm) {
                                this.$refs.pwdLoginForm.clearValidate();
                            }

                            this.$refs.registerForm.resetFields();

                            this.isRegister = false;
                            this.isLogin = true;
                        });
                    } else {
                        const errorMsg = res?.data?.message || '注册失败，请重试';
                        this.$message.error(errorMsg);
                    }
                } catch (error) {
                    console.error('注册请求异常:', error);
                    this.$message.error('注册失败，请稍后重试');
                } finally {
                    this.isLoading = false;
                    this.isPuzzle = false;
                    this.sliderValid = false;
                }
            }
            else if (this.isForget) {
                this.isLoading = true;
                try {
                    const res = await loginApi.forgetPassword(this.forgetForm);
                    if (res && (res.status === 200 || res.status === 201)) {
                        this.$message.success("重置密码成功, 请登录");

                        this.isForget = false;
                        this.isLogin = true;
                        this.activeName = 'pwdLoginForm';

                        this.pwdLoginForm.phoneNumber = this.forgetForm.phoneNumber;
                        this.pwdLoginForm.password = '';

                        this.$nextTick(() => {
                            if (this.$refs.pwdLoginForm) {
                                this.$refs.pwdLoginForm.clearValidate();
                            }
                        });
                    } else {
                        const errorMsg = res?.data?.message || '重置密码失败，请重试';
                        this.$message.error(errorMsg);
                    }
                } catch (error) {
                    console.error('重置密码请求异常:', error);
                    this.$message.error('重置密码失败，请稍后重试');
                } finally {
                    this.isLoading = false;
                    this.isPuzzle = false;
                    this.sliderValid = false;
                }
            }
        },
        onClose() {

        },
        onFail() {
            this.sliderValid = false;
            this.msg = "";
        },
        onRefresh() {
            this.sliderValid = false;
            this.msg = "";
        },
        handleSuccess() {
            console.log("拼图验证码验证成功");
        },
        handleFail() {
            console.log("拼图验证码验证失败");
        },
        refresh() {
            console.log("用户点击了初始化");
        },
        getUser() {
            const user = this.decryptUserInfo();
            if (!user) {
                this.pwdLoginForm.remberme = false;
                return;
            }
            this.pwdLoginForm.password = user.password;
            this.pwdLoginForm.phoneNumber = user.phoneNumber;
            this.pwdLoginForm.remberme = true;
        },
        encryptUserInfo(phoneNumber, password) {
            const user = {
                phoneNumber,
                password,
            };
            const userStr = JSON.stringify(user);
            localStorage.setItem("u", encrypt(userStr));
        },
        decryptUserInfo() {
            const userStr = localStorage.getItem("u");
            if (!userStr) return;
            const user = JSON.parse(decrypt(userStr));
            return user;
        },
        handleClick(name) {
            console.log('===name=====', name)
            this.sliderValid = false;
            if (name === "registerForm") {
                this.toRegister()
                return
            }
            this.activeName = name;

        },
        toRegister() {
            this.isLogin = false;
            this.isForget = false;
            this.isRegister = true;
            this.$nextTick(() => {
                this.$refs.registerForm.resetFields();
            });
        },
        async openPrivatePolicy() {
            const newWindow = window.open('', '_blank');

            let res = await getPrivatePolicy();
            if (!res) return
            newWindow.document.write(res.data);
            newWindow.document.close();

        },
        async openServiceItem() {
            const newWindow = window.open('', '_blank');

            let res = await getServiceItems();
            if (!res) return
            newWindow.document.write(res.data);
            newWindow.document.close();

        },
        submitForm(formName) {
            if (this.isLoading) return;
            let phoneNumber = this[formName].phoneNumber;
            try {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        let res = {};
                        if (formName === "pwdLoginForm") {
                            this.isPuzzle = true;
                        } else if (formName === "codeLoginForm") {
                            this.isLoading = true;
                            res = await loginApi.loginByCode(this[formName]);
                            this.isLoading = false;
                            if (!res || res.status !== 200) {
                                return;
                            } else {
                                store.commit("setToken", res.data.token);
                                store.commit("setUser", { phoneNumber });
                                this.$message.success("登录成功");
                                this.$router.push({ path: "/chatSearch/exercises" });
                            }
                        } else if (formName === "registerForm") {
                            this.isPuzzle = true;

                        } else {
                            this.isPuzzle = true
                        }
                    } else {
                        console.log("error submit!!");
                        return false;
                    }
                });
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },

        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        createPwdValidCode(data) {
            this.pwdLoginForm_code = data;
        },
        createCodeValidCode(data) {
            this.codeLoginForm_code = data;
        },
        createRegisterValidCode(data) {
            this.registerForm_code = data;
        },
        getPass(val, msg) {
            this.registerForm.password = val;
            this.registerForm.passwordMsg = msg;
        },
        toResetPwd() {
            this.isLogin = false;
            this.isForget = true;
        },
        
        async sendSmsCode(refname) {
        if (this[refname + "_send"]) {
            return;
        }
        let isValid = false;
        this.$refs[refname].validateField(["phoneNumber"], (err) => {
            isValid = !err;
        });
        if (!isValid) return;
        if (this[refname + "_count"] < 60) {
            return;
        }

        this[refname + "_send"] = true;
        if (this[refname + "_timer"]) clearInterval(this[refname + "_timer"]);
        this[refname + "_count"] = 60;
        this[refname + "_timer"] = setInterval(() => {
            if (this[refname + "_count"] === 1) {
            clearInterval(this[refname + "_timer"]);
            this[refname + "_count"] = 60;
            this[refname + "_timer"] = null;
            } else {
            this[refname + "_count"]--;
            }
        }, 1000);

        try {
            let res = await loginApi.sendSmsCode(this[refname]);
            if (res.status === 200) {
            this.$message.success(res.data.message);
            } else {
            this.$message.error(res.data.message);
            }
        } catch (error) {
            console.error("验证码发送接口异常：", error);
            this.$message.error("验证码发送失败，请稍后重试！");
            clearInterval(this[refname + "_timer"]);
            this[refname + "_count"] = 60;
            this[refname + "_timer"] = null;
        } finally {
            this[refname + "_send"] = false;
        }
        },

        // ---------- 分形树动画 ----------
        initFractalTree() {
            const svg = this.$refs.fractalSvg;
            if (!svg) return;
            const ns = 'http://www.w3.org/2000/svg';
            const centerX = 300,
                groundY = 350,
                maxDepth = 8,
                baseLen = 100,
                angleSpread = 0.62;
            let progress = 0.0,
                state = 'growing',
                holdCounter = 0,
                time = 0;
            const growthSpeed = 0.002,
                holdDuration = 600;
            const colors = {
                trunk: '#6D4C41',
                branch: '#8D6E63',
                twig: '#66BB6A',
                leaf: ['#FFB74D', '#FF8A65', '#CE93D8', '#81D4FA', '#A5D6A7', '#FFF59D']
            };
            const stars = [];
            for (let i = 0; i < 70; i++) {
                stars.push({
                    x: 12 + Math.random() * 476,
                    y: 12 + Math.random() * 376,
                    r: 0.8 + Math.random() * 2.8,
                    phase: Math.random() * Math.PI * 2,
                    speed: 0.3 + Math.random() * 1.6,
                    opacityBase: 0.4 + Math.random() * 0.5
                });
            }
            const FILTER_ID = 'ft-glow-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
            const easeInOut = t => t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;

            const drawTree = () => {
                while (svg.firstChild) svg.removeChild(svg.firstChild);
                
                const defs = document.createElementNS(ns, 'defs');
                const filter = document.createElementNS(ns, 'filter');
                filter.setAttribute('id', FILTER_ID);
                filter.setAttribute('x', '-50%');
                filter.setAttribute('y', '-50%');
                filter.setAttribute('width', '200%');
                filter.setAttribute('height', '200%');
                const blur = document.createElementNS(ns, 'feGaussianBlur');
                blur.setAttribute('stdDeviation', '1.8');
                blur.setAttribute('result', 'blur');
                const merge = document.createElementNS(ns, 'feMerge');
                merge.appendChild(document.createElementNS(ns, 'feMergeNode')).setAttribute('in', 'blur');
                merge.appendChild(document.createElementNS(ns, 'feMergeNode')).setAttribute('in', 'SourceGraphic');
                filter.appendChild(blur);
                filter.appendChild(merge);
                defs.appendChild(filter);
                svg.appendChild(defs);
                
                for (const star of stars) {
                    const twinkle = 0.5 + 0.5 * Math.sin(time * star.speed + star.phase);
                    const opacity = star.opacityBase * (0.5 + 0.5 * twinkle);
                    const size = star.r * (0.8 + 0.2 * twinkle);
                    const circle = document.createElementNS(ns, 'circle');
                    circle.setAttribute('cx', star.x);
                    circle.setAttribute('cy', star.y);
                    circle.setAttribute('r', size);
                    circle.setAttribute('fill', '#FFD700');
                    circle.setAttribute('opacity', opacity);
                    circle.setAttribute('filter', `url(#${FILTER_ID})`);
                    svg.appendChild(circle);
                }

                const raw = Math.min(Math.max(progress, 0), 1.0);
                const eased = easeInOut(raw);
                const scale = 0.08 + 0.92 * eased;
                const wind = 0.15 * Math.sin(time * 0.6) + 0.05 * Math.sin(time * 0.9 + 1.2);

                function branch(len, angle, x0, y0, depth) {
                    if (depth > maxDepth || len < 1.2) return;
                    const windOffset = wind * (1 + depth * 0.10);
                    const currentAngle = angle + windOffset;
                    const x1 = x0 + len * Math.cos(currentAngle);
                    const y1 = y0 - len * Math.sin(currentAngle);
                    const line = document.createElementNS(ns, 'line');
                    line.setAttribute('x1', x0);
                    line.setAttribute('y1', y0);
                    line.setAttribute('x2', x1);
                    line.setAttribute('y2', y1);
                    let strokeW = Math.max(0.2, (maxDepth - depth + 1) * 0.5);
                    if (depth < 2) strokeW *= (0.8 + 0.5 * scale);
                    line.setAttribute('stroke-width', strokeW);
                    let strokeColor;
                    if (depth < 2) strokeColor = colors.trunk;
                    else if (depth < 4) strokeColor = colors.branch;
                    else if (depth < 6) strokeColor = colors.twig;
                    else strokeColor = '#4CAF50';
                    line.setAttribute('stroke', strokeColor);
                    line.setAttribute('stroke-linecap', 'round');
                    svg.appendChild(line);

                    if (depth >= maxDepth - 2 || len < 3.5) {
                        const flower = document.createElementNS(ns, 'circle');
                        flower.setAttribute('cx', x1);
                        flower.setAttribute('cy', y1);
                        const bloom = 0.3 + 0.7 * eased;
                        const size = 1.5 + 3.0 * bloom * (0.6 + 0.4 * Math.sin(time * 1.2 + depth * 1.2));
                        flower.setAttribute('r', size);
                        const colIdx = Math.floor((time * 0.3 + depth * 0.7) % colors.leaf.length);
                        flower.setAttribute('fill', colors.leaf[colIdx % colors.leaf.length]);
                        flower.setAttribute('opacity', 0.7 + 0.3 * eased);
                        svg.appendChild(flower);
                    }
                    const nextLen = len * (0.68 + 0.08 * (0.5 + 0.5 * Math.sin(time * 0.5 + depth * 0.3)));
                    const spread = angleSpread * (0.80 + 0.20 * eased);
                    branch(nextLen, currentAngle + spread, x1, y1, depth + 1);
                    branch(nextLen, currentAngle - spread, x1, y1, depth + 1);
                }
                branch(baseLen * scale, Math.PI / 2, centerX, groundY, 0);

                const text = document.createElementNS(ns, 'text');
                text.setAttribute('x', centerX);
                text.setAttribute('y', groundY + 28);
                text.setAttribute('text-anchor', 'middle');
                text.setAttribute('font-family', '"PingFang SC", "Microsoft YaHei", sans-serif');
                text.setAttribute('font-size', '15');
                text.setAttribute('font-weight', '500');
                text.setAttribute('fill', '#6a8aaa');
                text.setAttribute('letter-spacing', '2');
                text.setAttribute('opacity', 0.6 + 0.4 * (0.5 + 0.5 * Math.sin(time * 0.3)));
                text.textContent = '探数蚁陪您一起探索';
                svg.appendChild(text);

                const lineDeco = document.createElementNS(ns, 'line');
                lineDeco.setAttribute('x1', centerX - 70);
                lineDeco.setAttribute('y1', groundY + 36);
                lineDeco.setAttribute('x2', centerX + 70);
                lineDeco.setAttribute('y2', groundY + 36);
                lineDeco.setAttribute('stroke', '#c5d5e8');
                lineDeco.setAttribute('stroke-width', '0.8');
                lineDeco.setAttribute('opacity', '0.35');
                lineDeco.setAttribute('stroke-dasharray', '4 4');
                svg.appendChild(lineDeco);
            };

            const animate = () => {
                if (state === 'growing') {
                    progress += growthSpeed;
                    if (progress >= 1.0) { progress = 1.0; state = 'holding'; holdCounter = 0; }
                } else if (state === 'holding') {
                    holdCounter++;
                    if (holdCounter >= holdDuration) { progress = 0.0; state = 'growing'; holdCounter = 0; }
                }
                time += 0.02;
                drawTree();
                this.fractalAnimId = requestAnimationFrame(animate);
            };
            animate();
        },

        // ---------- 移动端卡片滚动自动激活 ----------
        observeCards() {
            const cards = document.querySelectorAll('.feature-card');
            if (!cards.length) return;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('active');
                    } else {
                        entry.target.classList.remove('active');
                    }
                });
            }, {
                threshold: 0.3,     
                rootMargin: '-30% 0px -30% 0px'
            });

            cards.forEach(card => observer.observe(card));
            this.cardObserver = observer;
        },
    },
};
</script>

<style lang="scss" scoped>
$main_color:rgb(17, 2, 236);
$input_width: 380PX;

* {
    box-sizing: border-box;
}

/* 全局重置 —— 建议放在外部全局样式，此处为防遗漏 */
html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    overflow: hidden;   /* 防止页面整体滚动，由 #container 内部滚动 */
}

#container {
    display: flex;
    flex-direction: column;
    height: 100vh;          /* fallback for older browsers */
    height: 100dvh;         /* 动态视口高度，适配移动端 */
    overflow-y: auto;       /* 内部滚动 */
    overflow-x: hidden;
    min-width: 600px;
}

.header {
    align-items: center;
    display: flex;
    padding-left: 32PX;
    padding-right: 32PX;
    background-color: #fff;
    height: 60PX;
    line-height: 60PX;
    z-index: 1000;
    justify-content: space-between;
    flex-shrink: 0;

    .project-title {
        display: flex;
        align-items: center;
        flex-shrink: 0;

        img {
            cursor: pointer;
            display: block;
            max-height: 55px;
        }

        span {
        display: inline-block;          /* 让背景裁剪生效 */
        font-weight: 800;
        font-size: 32px;               /* 可保留原大小，若想更精致可改为 24px */
        letter-spacing: -0.5px;
        vertical-align: middle;
        background: linear-gradient(135deg, #2e5bff, #7c3aed);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }
    }

    .operate-wrap {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-shrink: 0;
    }

    .download-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 0 22px;
    height: 40px;
    border-radius: 60px;
    background: linear-gradient(135deg, #2e5bff, #7c3aed);
    color: #fff;
    border: none;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    white-space: nowrap;
    box-shadow: 0 4px 16px rgba(46, 91, 255, 0.30);

    svg {
        flex-shrink: 0;
        transition: transform 0.3s ease;
    }

    &:hover {
        transform: translateY(-2px) scale(1.02);
        box-shadow: 0 8px 28px rgba(46, 91, 255, 0.40);
        svg {
            transform: translateY(-1px);
        }
    }

    &:active {
        transform: translateY(0) scale(0.97);
        box-shadow: 0 2px 8px rgba(46, 91, 255, 0.25);
    }

    .download-text {
        line-height: 1.2;
        font-family: var(--m-font-family, Inter, -apple-system, BlinkMacSystemFont, Segoe UI, SF Pro SC, SF Pro Display, SF Pro Icons, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif);
    }
    }

    .login-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 0 22px;
    height: 40px;
    border-radius: 60px;
    background: transparent;
    color: #2e5bff;
    border: 1.5px solid #2e5bff;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    white-space: nowrap;

    svg {
        flex-shrink: 0;
        transition: transform 0.3s ease;
    }

    &:hover {
        background: #2e5bff;
        color: #fff;
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(46, 91, 255, 0.30);
        border-color: #2e5bff;
        svg {
            transform: translateX(2px);
        }
    }

    &:active {
        transform: translateY(0) scale(0.97);
        box-shadow: 0 2px 8px rgba(46, 91, 255, 0.20);
    }
}

    span {
        font-weight: 700;
        font-size: 28PX;
        vertical-align: middle;

    }

    .arco-select,
    .arco-select-view {
        display: none;
    }
}

/* ===== 登录面板 ===== */
.layout-new {
    flex: 1;
    background: transparent;
    background-repeat: no-repeat;
    background-size: cover;
    display: none;
    z-index: 3001;
    position: absolute;
    top: 18%;
    right: 0;
    transform: translate(-50%, 0);

    .container {
        z-index: 3001;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        margin: 0 auto;
        max-width: 1200PX;
        min-height: 400PX;
        padding: 0 40PX;
        position: relative;

        .left-banner {
            align-items: center;
            display: flex;
            flex: 1 1;
            height: 100%;
            position: relative;
            visibility: hidden;
            display: none;

            .hotspot {
                max-width: 540PX;
                max-width: 100%;
                min-height: 400PX;

                img {
                    max-width: 540PX;
                    object-fit: contain;
                    width: 100%;
                }
            }
        }

        .layout-spin {
            width: 100%;
            display: flex;
            justify-content: center;

            .arco-spin-children {
                position: relative;
                display: flex;

            }

            .card-has-tab {
                display: flex;
                flex-direction: column;
                padding: 48PX 43PX 32PX;
                align-items: center;

            }

            .login-card,
            .forget-card {
                width: $input_width;
                background: linear-gradient(145deg,rgba(222, 230, 250, 0.91),rgb(226, 233, 250)) !important;
                border-radius: 20PX;
                box-shadow: 0 20px 60px rgba(143, 46, 255, 0.1);
                border: 1px solid rgba(255,255,255,0.5);
                box-sizing: border-box;
                min-height: 280PX;
                padding: 48px 18px 32px;
                position: relative;
                width: 476PX;
                z-index: 22;

                .title {
                    color: #0c0d0e;
                    font-size: 24PX;
                    font-weight: 500;
                    letter-spacing: .003em;
                    line-height: 32PX;
                }


                .arco-tabs-header {
                    display: flex;
                    position: relative;
                    transition: transform .2s cubic-bezier(.34, .69, .1, 1);
                    white-space: nowrap;
                    height: 38PX;
                    font-size: 16PX;

                    .arco-tabs-header-title {
                        padding: 8PX 0 6PX 0;
                        position: relative;

                        &:hover {
                            .tabs-text {
                                color: $main_color;
                                font-size: 16PX;
                                font-weight: 500;
                                line-height: 22PX;
                            }

                            font-weight: 500;
                            cursor: pointer;
                        }

                        &.active {
                            color: $main_color;

                            .tabs-text {
                                color: $main_color;
                            }

                            .header-ink {
                                background-color: $main_color;
                            }
                        }

                        &:nth-child(2) {
                            margin-left: 18PX;
                            margin-right: 18PX;
                        }

                        .header-ink {
                            bottom: 1PX;
                            width: 100%;
                            border-radius: 4PX 4PX 0 0;
                            bottom: 0;
                            height: 2PX;
                            position: absolute;
                            transition: left .2s cubic-bezier(.34, .69, .1, 1), width .2s cubic-bezier(.34, .69, .1, 1);
                        }

                    }



                }



                .el-tabs {
                    ::v-deep .el-tabs__nav-wrap {
                        margin: 10PX auto 20PX;
                        width: 180PX;
                        font-size: 16PX;
                        font-weight: 500;
                        line-height: 22PX;
                    }
                }

                ::v-deep .el-tabs__nav-wrap::after {
                    background-color: #fff;
                }

                .el-form {
                    padding-top: 20PX;
                    width: $input_width;
                    margin: 0 auto;
                    display: flex;
                    flex-direction: column;
                    height: auto;
                    flex-direction: column;
                    z-index: 3001;

                    .el-form-item {
                        width: 100%;
                        margin-bottom: 20PX;
                    }

                    .el-input {
                        ::v-deep .el-input__inner {
                            height: 40PX;
                            background-color: #ffffff;           // 改为白色，更干净
                            border: 1.5px solid #d0deff;         // 添加浅蓝色边框（与功能卡片边框呼应）
                            border-radius: 8PX;                  // 适当圆角，与按钮圆角协调
                            transition: border-color 0.3s ease;

                            // 输入框聚焦时的状态
                            &:focus {
                                border-color: #2e5bff;            // 聚焦时变为品牌主色
                                box-shadow: 0 0 0 3px rgba(46, 91, 255, 0.1); // 可选聚焦光晕
                            }

                            &::placeholder {
                                color: #999;
                                opacity: 0.6;
                            }
                        }
                    }

                    .puzzle-item {
                        margin: 0 auto;
                        padding: 20PX;
                        box-sizing: border-box;
                        width: 100%;
                        background: linear-gradient(45deg,
                                rgba(220, 150, 150, 0.8),
                                rgba(150, 150, 240, 0.8));
                        border: dashed 1PX #ccc;
                        border-radius: dashed;

                        ::v-deep .slide-verify-slider {
                            margin-top: 10PX;
                            height: 50PX;
                            line-height: 50PX;
                            border-radius: 3PX;
                            box-shadow: 0 0 8PX #f0f0f099 inset;
                        }

                        ::v-deep .slide-verify-slider-text {
                            color: #666;
                            opacity: 0.4;
                            font-style: italic;
                        }

                        ::v-deep .slide-verify-slider-mask {
                            height: 50PX;
                            border: none;
                        }

                        ::v-deep .slide-verify-slider-mask-item {
                            height: 50PX;
                            padding: 0 5PX;

                            .slide-verify-slider-mask-item-icon {
                                position: relative;
                                top: 20PX;
                            }
                        }

                        ::v-deep .container-success .slide-verify-slider-mask-item {
                            height: 52PX;
                        }
                    }

                    .validPassword-item {
                    }

                    .strength-item {
                        margin-bottom: 5PX;
                        margin-top: -15PX;
                    }

                    .verify_item .el-form-item__content {
                        .verifycode-btn {
                            position: absolute;
                            border: 0;
                            top: 50%;
                            right: 15PX;
                            transform: translateY(-50%);
                            color: $main_color;
                            background: none;
                        }

                        .code-btn-able {
                            cursor: pointer;
                        }
                    }

                    .remberme-item {
                        margin-top: 8PX;
                        margin-bottom: -22PX;

                        .el-button {
                            ::v-deep span {
                                color: #3f9bf3;
                            }
                        }

                        .el-checkbox {
                            ::v-deep span {
                                color: #3f9bf3;
                            }
                        }
                    }

                    .operate-item {

                        color: $main_color;

                        width: 100%;

                        &.register {
                        }

                        ::v-deep .el-form-item__content {
                            width: 100%;
                            display: flex;
                            display: flex;
                            flex-direction: column;

                        }

                        .protocol {

                            color: #41464f;
                            font-size: 12PX;
                            font-weight: 400;
                            line-height: 20PX;
                            margin-bottom: 4PX;
                            margin-top: 10px;

                            a {
                                color: $main_color
                            }
                        }

                        .el-button {
                            margin: 20PX 0 6PX;
                            display: inline-block;
                            width: 100%;
                            background-color: $main_color;
                            height: 40PX;

                            ::v-deep span {
                                color: #fff;
                            }

                            &.close-btn {
                                background: transparent !important;
                                border: 1.5px solid #2e5bff !important;
                                color: #2e5bff !important;          // 作用于按钮本身，但 span 会覆盖
                                font-weight: 600 !important;
                                transition: all 0.3s ease;

                                // 👇 新增：覆盖内部 span 的颜色
                                ::v-deep span {
                                    color: #2e5bff !important;
                                }

                                &:hover {
                                    background: #2e5bff !important;
                                    color: #fff !important;
                                    ::v-deep span {
                                        color: #fff !important;     // 悬停时 span 变白
                                    }
                                    box-shadow: 0 4px 16px rgba(46, 91, 255, 0.25);
                                }

                                &:active {
                                    transform: scale(0.96);
                                }
                            }
                        }
                    }
                }

                .account-tab {
                    margin-top: 20PX;
                }

                .link-wrap {
                    margin-top: -10PX;
                    width: $input_width;

                    .forget-pwd {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }

                    ::v-deep .el-checkbox__label {
                        color: $main_color;


                    }

                    ::v-deep .el-checkbox__inner {
                        &.is-checked {
                            background-color: $main_color !important;
                            border-color: $main_color !important;
                        }

                        &:hover {
                            border-color: $main_color !important;
                        }
                    }

                    .text {
                        font-size: 13PX;
                        font-weight: 400;
                        line-height: 22PX;
                        color:rgb(247, 144, 84);

                        &:hover {
                            color: $main_color;
                        }
                    }
                }

                .suffix-node {
                    align-items: center;
                    color: #41464f;
                    display: flex;
                    font-size: 14PX;
                    font-weight: 400;
                    justify-content: center;
                    line-height: 22PX;
                    margin-top: 20PX;

                    span {
                        color: $main_color;
                        font-weight: 500;

                    }
                }
            }
        }

    }
}

.panel-show {
    display: block;
}

a {
    cursor: pointer !important;
    text-decoration: none;
}

.know-position {
    /* 移除固定定位，使用 flex 布局自适应 */
}

.know-wrap {
    flex: 1 1 auto;           /* 占满剩余高度，内容过多时撑开以滚动 */
    margin: 0 auto;
    height: auto !important;
    width: 99vw;
    background-color: #f8faff;
    padding-bottom: 20px;
    isolation: isolate;
    overflow: visible;         /* 不产生额外滚动，由父容器控制 */
}

/* ===== Landing 内容样式 ===== */
.landing-content {
    max-width: 1280px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
}

.hero {
    padding: 40px 40px 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0px;
    min-height: 70vh;

    .hero-left {
        flex: 1;
    }
    .hero-right {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .hero-tag {
        display: inline-flex;
        align-items: center;
        justify-content: center;   // 保证内容水平居中
        gap: 8px;
        height: 36px;              // 固定高度，与 tech-arch-link 一致
        padding: 0 18px;           // 垂直内边距由 height 控制，水平保留
        background: #eef3ff;
        border-radius: 40px;
        font-size: 14px;
        font-weight: 600;
        color: #2e5bff;
        margin-bottom: 0;          // 清除原 margin-bottom: 20px
        border: 1px solid #d0deff;
        .sparkle {
            animation: sparkle 1.8s infinite;
        }
    }

    h1 {
        font-size: clamp(38px, 6vw, 64px);
        font-weight: 900;
        line-height: 1.15;
        letter-spacing: -1px;
        color: #0f1a2e;
        margin-bottom: 16px;
        .highlight {
            background: linear-gradient(135deg, #2e5bff, #a855f7);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
        }
        .ant-emoji {
            display: inline-block;
            font-size: 1.1em;
            animation: bounce-ant 3s infinite;
        }
    }

    p {
        font-size: clamp(16px, 2vw, 20px);
        color: #4b5e7a;
        max-width: 560px;
        margin-bottom: 32px;
        line-height: 1.7;
    }

    .hero-actions {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    }

    .btn-hero {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 56px;               // 固定高度
    padding: 0 38px;            // 统一内边距
    border-radius: 60px;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;             // 消除行高影响
    border: 2px solid transparent; // 所有按钮都有边框占位
    cursor: pointer;
    transition: all 0.35s;
    gap: 10px;
    box-sizing: border-box;
    flex-shrink: 0;             // 防止压缩
    
    &.btn-hero-primary {
        background: linear-gradient(135deg, #2e5bff, #7c3aed);
        color: #fff;
        border-color: transparent;
        box-shadow: 0 8px 28px rgba(46, 91, 255, 0.3);
        &:hover {
        transform: translateY(-4px) scale(1.02);
        box-shadow: 0 16px 40px rgba(46, 91, 255, 0.4);
        }
    }
    
    &.btn-hero-secondary {
        background: #fff;
        color: #2e5bff;
        border-color: #d0deff;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
        &:hover {
        border-color: #2e5bff;
        transform: translateY(-4px);
        box-shadow: 0 12px 28px rgba(46, 91, 255, 0.12);
        }
    }
    }


    .hero-illustration {
        width: 100%;
        max-width: 600px;
        aspect-ratio: 1 / 1;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 24px;
        overflow: hidden;
        svg {
            width: 100%;
            height: 100%;
            display: block;
        }
    }
}

/* ---- 技术架构链接（改成按钮框样式，与左侧标签对齐） ---- */
.tech-arch-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;              // 与左侧标签高度匹配
  padding: 0 18px;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 600;
  color: #7c3aed;
  border: 1.5px solidrgb(176, 135, 248);
  background: #f3efff;
  cursor: pointer;
  transition: all 0.25s ease;
  white-space: nowrap;
  vertical-align: middle;     // 确保与左侧标签基线对齐
  box-sizing: border-box;
  
  &:hover {
    background: #ede9fe;
    box-shadow: 0 4px 12px rgba(124, 58, 237, 0.2);
    transform: translateY(-1px);
  }
}

@keyframes sparkle {
    0%, 100% { transform: scale(1) rotate(0deg); opacity: 1; }
    50% { transform: scale(1.2) rotate(15deg); opacity: 0.7; }
}
@keyframes bounce-ant {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-10px); }
}

/* ===== 核心功能区域 ===== */
.section {
  padding: 80px 40px;
  max-width: 1280px;
  margin: 0 auto;
  background:transparent;
  position: relative;
  z-index: 1;
}

.section-title {
    text-align: center;
    margin-bottom: 56px;
    h2 {
        font-size: clamp(28px, 4vw, 42px);
        font-weight: 800;
        color: #0f1a2e;
        margin-bottom: 12px;
    }
    p {
        font-size: 17px;
        color: #5b6f8c;
        max-width: 600px;
        margin: 0 auto;
    }
}

.features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 28px;
}

.feature-card {
    background: linear-gradient(135deg, #f8faff 0%, #eef3ff 100%);
    border-radius: 28px;
    padding: 32px 28px;
    box-shadow: 0 8px 32px rgba(46, 91, 255, 0.06);
    transition: all 0.4s;
    border: 1px solid #edf2ff;
    position: relative;
    overflow: hidden;
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: linear-gradient(90deg, #2e5bff, #a855f7, #f472b6);
        opacity: 0;
        transition: opacity 0.4s;
    }
    &:hover,
    &.active {                     // 移动端滚动到中间时自动添加 active 类
        background: linear-gradient(135deg, #eef3ff 0%, #dfe9ff 100%);
        transform: translateY(-8px);
        box-shadow: 0 20px 48px rgba(46, 91, 255, 0.12);
        border-color: #c8d9ff;
        &::before { opacity: 1; }
        h3 {
        display: block; 
        width: fit-content;          
        width: -moz-fit-content;     
        background: linear-gradient(135deg, rgb(34, 30, 253), rgb(204, 6, 243));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        }

    }
    .feature-icon {
        font-size: 40px;
        margin-bottom: 16px;
        background: #eef3ff;
        width: 64px;
        height: 64px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
    }
    h3 {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 10px;
        color: #0f1a2e;
    }
    p {
        font-size: 15px;
        color: #4b5e7a;
        line-height: 1.7;
    }
    .tag-new, .tag-hot, .tag-ai {
        display: inline-block;
        padding: 2px 12px;
        border-radius: 40px;
        font-size: 12px;
        font-weight: 700;
        margin-top: 12px;
    }
    .tag-new { background: #dcfce7; color: #16a34a; }
    .tag-hot { background: #fef3c7; color: #d97706; }
    .tag-ai { background: #ede9fe; color: #7c3aed; }
}

/* 四选项卡 */
.features-alt {
    background: linear-gradient(135deg, #f0f6ff 0%, #f5f0ff 100%);
    border-radius: 48px;
    padding: 60px 48px;
    margin: 0 40px 80px;
}

.tabs-nav {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    background: rgba(255, 255, 255, 0.55);
    border-radius: 60px;
    padding: 6px;
    margin-bottom: 32px;
    border: 1px solid rgba(255, 255, 255, 0.7);
    box-shadow: 0 2px 16px rgba(46, 91, 255, 0.06);
    justify-content: center;
}
.tab-btn {
    flex: 1 1 auto;
    min-width: 120px;
    padding: 12px 24px;
    border: none;
    border-radius: 40px;
    background: transparent;
    font-size: 15px;
    font-weight: 600;
    color: #4b5e7a;
    cursor: pointer;
    transition: all 0.35s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    white-space: nowrap;
    font-family: inherit;
    &:hover {
        color: #2e5bff;
        background: rgba(46,91,255,0.06);
    }
    &.active {
        background: #fff;
        color: #2e5bff;
        box-shadow: 0 4px 20px rgba(46,91,255,0.15);
        transform: scale(1.02);
    }
    .tab-icon { font-size: 18px; }
}

.tabs-content {
    position: relative;
    min-height: 280px;
}
.tab-panel {
    display: none;
    animation: tabFadeIn 0.45s ease forwards;
    &.active { display: block; }
}
@keyframes tabFadeIn {
    0% { opacity: 0; transform: translateY(14px); }
    100% { opacity: 1; transform: translateY(0); }
}

.panel-inner {
    background: rgba(255, 255, 255, 0.75);
    border-radius: 32px;
    padding: 40px 44px;
    border: 1px solid rgba(255, 255, 255, 0.7);
    box-shadow: 0 8px 32px rgba(46, 91, 255, 0.04);
    
    .qr-code-wrapper {
        display: flex;
        gap: 40px;
        justify-content: center;
        align-items: flex-start;
        flex-wrap: wrap;
        margin-top: 16px;

        .qr-code-block {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 0;   // 移除原有 margin-top，由 wrapper 控制

            .qr-code-large {
                width: 100px;
                height: 100px;
                border-radius: 8px;
                border: 1px solid #e0e8f0;
                object-fit: contain;
                background: #fff;
            }

            .qr-tip-text {
                font-size: 13px;
                color: #6a7a8e;
                margin-top: 6px;
            }
            &:first-child .qr-tip-text {
                margin-top: 12px;   // 只调整左侧“扫码联系”往下移
            }
        }

        // 下载二维码特有的下方链接行
        .qr-code-download {
            .qr-download-links {
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 8px;
                margin-top: 6px;

                .sep {
                    color: #d0d8e0;
                    font-weight: 300;
                }

                .download-link {
                    color: #2e5bff;
                    text-decoration: none;
                    font-weight: 600;
                    cursor: pointer;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
    }

    // 移动端适配：小屏幕垂直排列
    @media screen and (max-width: 600px) {
        .qr-code-wrapper {
            gap: 24px;
            flex-direction: column;
            align-items: center;
        }
    }
    .panel-head {
        display: flex;
        align-items: center;
        gap: 14px;
        margin-bottom: 20px;
        .big-icon {
            font-size: 36px;
            background: #eef3ff;
            width: 60px;
            height: 60px;
            border-radius: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
        }
        h3 {
            font-size: 24px;
            font-weight: 800;
            color: #0f1a2e;
            margin: 0;
            .accent {
                background: linear-gradient(135deg, #2e5bff, #7c3aed);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
            }
        }
    }
    .panel-body {
        font-size: 16px;
        color: #3d4f6f;
        line-height: 1.8;
        p { margin-bottom: 16px; &:last-child { margin-bottom: 0; } }
        strong { color: #1e2a3e; font-weight: 700; }
        .highlight-text { color: #2e5bff; font-weight: 600; }
        .highlight-purple { color: #7c3aed; font-weight: 600; }
    }
    .tag-group {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 20px;
        padding-top: 20px;
        border-top: 2px dashed rgba(46,91,255,0.10);
        .mini-tag {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 6px 16px;
            background: #f0f4ff;
            border-radius: 40px;
            font-size: 13px;
            font-weight: 600;
            color: #2e5bff;
            border: 1px solid #d0deff;
            .emoji { font-size: 15px; }
        }
    }
    .quote-block {
        background: #f5f0ff;
        border-radius: 20px;
        padding: 24px 28px;
        margin: 16px 0 8px;
        border-left: 4px solid #7c3aed;
        font-style: italic;
        color: #3d4f6f;
        font-size: 15px;
        line-height: 1.8;
        .quote-source {
            display: block;
            margin-top: 8px;
            font-style: normal;
            font-weight: 600;
            color: #2e5bff;
        }
    }
}

/* 新增关于我们样式 */
.contact-links-vertical {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 16px 0 8px;
    .link-item {
        font-size: 15px;
        color: #2e5bff;
        cursor: pointer;
        &:hover {
            text-decoration: underline;
        }
        &.contact-email {
            color: #4b5e7a;
            cursor: default;
            &:hover {
                text-decoration: none;
            }
        }
    }
}
.qr-code-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 16px;
    .qr-code-large {
        width: 100px;
        height: 100px;
        border-radius: 8px;
        border: 1px solid #e0e8f0;
    }
    .qr-tip-text {
        font-size: 13px;
        color: #6a7a8e;
        margin-top: 6px;
    }
}

/* ===== 页面底部版权信息（直接写在内容区） ===== */
.page-bottom-copyright {
    text-align: center;
    padding: 30px 20px 20px;
    font-size: 13px;
    color: #6a7a8e;
    border-top: 1px solid rgba(46, 91, 255, 0.08);
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px 12px;

    a {
        color: #6a7a8e;
        text-decoration: none;
        transition: color 0.2s;
        &:hover {
            color: $main_color;
            text-decoration: underline;
        }
    }
    .sep {
        color: #d0d8e0;
        font-weight: 300;
    }
}

/* ===== 响应式 ===== */
@media screen and (max-width: 1200PX) {
    #container {
        min-width: 200px;
    }

    .left-banner {
        display: none !important;
    }

    .layout-new {
        top: 10%;
        left: 50%;
        transform: translate(-50%, 0);

        .link-wrap {
            margin-top: -20PX !important;
            width: $input_width;
        }
    }

    .hero { flex-direction: column; padding: 30px 20px 40px; text-align: center; min-height: auto;
        p { max-width: 100%; margin-left: auto; margin-right: auto; }
        .hero-actions { justify-content: center; }
        .hero-right { order: -1; }
        .hero-illustration { max-width: 300px; }
    }
    .features-alt { margin: 0 16px 60px; padding: 36px 18px; border-radius: 32px; }
    .tabs-nav {
        border-radius: 28px; padding: 4px; gap: 4px;
        flex-wrap: nowrap; overflow-x: auto; justify-content: flex-start;
        -webkit-overflow-scrolling: touch; scrollbar-width: none;
        &::-webkit-scrollbar { display: none; }
        .tab-btn { min-width: 90px; padding: 10px 16px; font-size: 13px; flex: 0 0 auto; white-space: nowrap; .tab-icon { font-size: 16px; } }
    }
    .panel-inner { padding: 28px 20px; border-radius: 24px; .panel-head .big-icon { width: 48px; height: 48px; font-size: 28px; } h3 { font-size: 20px; } .panel-body { font-size: 15px; } }
    .page-bottom-copyright {
        font-size: 12px;
        padding: 20px 15px;
        gap: 4px 10px;
        flex-direction: column;
        .sep { display: none; }
    }
}

/* ===== 移动端修复：标题栏按钮靠右 ===== */
@media screen and (max-width: 768px) {
    .header {
        justify-content: flex-start;
        padding-left: 12px;
        padding-right: 12px;

        .project-title {
            flex-shrink: 0;
            img {
                max-height: 32px;
            }
            span {
                font-size: 20px;
                letter-spacing: -0.3px;
            }
        }

        .operate-wrap {
            flex-shrink: 0;
            margin-left: auto;
            gap: 6px;
        }

        .download-btn {
            padding: 0 12px;
            height: 34px;
            font-size: 12px;
            border-radius: 30px;

            svg {
                width: 15px;
                height: 15px;
            }

            .download-text {
                font-size: 11px;
            }

            &:hover {
                transform: translateY(-1px);
            }
        }

        .login-btn {
            padding: 0 12px;
            height: 34px;
            font-size: 12px;
            border-radius: 30px;

            svg {
                width: 15px;
                height: 15px;
            }

            span {
                font-size: 12px;
            }

            &:hover {
                transform: translateY(-1px);
            }
        }
    }

    .section { padding: 40px 20px 60px; }
    .section-title {
        h2 {
            font-size: 32px !important; 
        }
        p {
            font-size: 16px;
        }
    }
    .features-grid { grid-template-columns: 1fr; }
}

@media (max-width: 480px) {
    .header {
        .project-title {
            img {
                max-height: 28px;
            }
            span {
                font-size: 18px;
            }
        }

        .operate-wrap {
            gap: 4px;
            width: auto !important;   /* 覆盖原有 width:100% */
            flex-shrink: 0;
        }

        .download-btn {
            padding: 0 10px;
            height: 30px;
            font-size: 11px;
            border-radius: 24px;

            svg {
                width: 13px;
                height: 13px;
            }

            .download-text {
                font-size: 10px;
            }
        }

        .login-btn {
            padding: 0 10px;
            height: 30px;
            font-size: 11px;
            border-radius: 24px;

            svg {
                width: 13px;
                height: 13px;
            }

            span {
                font-size: 11px;
            }
        }
    }

    .hero h1 { font-size: 32px; }
    .section-title {
        h2 {
            font-size: 26px !important; 
        }
        p {
            font-size: 15px !important;
        }
    }
    .btn-hero { padding: 12px 24px; font-size: 14px; }
    .feature-card { padding: 24px 20px; }
    .features-alt { padding: 24px 12px; }
    .tab-btn { min-width: 70px; padding: 8px 12px; font-size: 12px; }
    .panel-inner { padding: 20px 14px; .panel-head .big-icon { width: 40px; height: 40px; font-size: 22px; } h3 { font-size: 17px; } }
    .page-bottom-copyright {
        font-size: 11px;
        padding: 16px 10px;
    }
}

@media screen and (max-height: 700PX) {
    #container {
        overflow: scroll;
    }

    .layout-new {
        font-size: 10PX;

        top: 10%;
        left: 50%;
        transform: translate(-50%, 0);

        .login {
            z-index: 3001;
        }

        .arco-tabs-header {
            justify-content: center;
        }

        .title {
            margin-top: 15px;
            text-align: center;
        }

        .link-wrap {
            text-align: center;
            justify-content: center !important;
        }

        .login-card,
        .forget-card {
            padding: 0.24rem 0.48rem 0.24rem !important;
            max-height: 600PX;
            margin-top: -30PX;
            background-color: #faf9f9 !important;
            box-shadow: 0 5px 15px #909399 !important;

            .title {
                font-size: 18PX !important;
                line-height: 1.5;
            }

            .account-tab {
                margin-top: 5PX !important;

            }

            .suffix-node {
                margin-top: 8PX !important;
                font-size: 12PX !important;
            }

            a {
                font-size: 12PX !important;
            }

            ::v-deep .el-checkbox__label {
                font-size: 12PX;
            }

            .link-wrap {
                margin-top: -20PX !important;
                width: 100% !important;
            }

        }



        .arco-tabs-header {
            font-size: 14PX;
        }

        .el-button {
            height: 34PX !important;
            line-height: 0;
        }

        ::v-deep .el-input__inner {
            height: 40PX !important;
        }

        .verify_item {
            margin-bottom: 10PX !important;

        }

        ::v-deep .el-form-item__error {
            font-size: 10PX;
            margin-top: -2 !important;
            padding-top: 0 !important;
        }

        .without-validcode {
            padding-top: 0 !important;

            .operate-item {
                margin-top: -20PX;

                .el-button {
                    margin-top: 5PX !important;
                }
            }

        }

    }

    .know-wrap {
        min-height: 300PX;
        top: 20px;

        ::v-deep .graph-wrapper {
            height: 90% !important;

            svg {
                background-color: #fff;
            }
        }

    }

}

/* 移动端调整：移除对 #container 高度的覆盖，确保固定高度生效 */
.isMobile {
    font-size: 0.18rem;
    // 不再覆盖 height，保持固定视口高度

    .login-card,
    .forget-card {
        padding-top: 15px;
        padding-bottom: 15px;
        max-width: 476PX;
        min-width: 300px;
        width: fit-content !important;

        .register-title {
            margin-bottom: 8px;
        }

        .el-form {
            min-width: 280px;
            max-width: 380px;
            width: fit-content !important;
        }
    }

    .layout-new {
        .container {
            height: 70vh;
        }
    }

    .know-wrap {
        flex: 1 1 auto;    /* 占满剩余高度，内容超出时父容器滚动 */
    }

    .page-bottom-copyright {
        padding: 16px 10px;
        font-size: 11px;
        flex-direction: column;
        gap: 2px;
        .sep { display: none; }
    }
}
.operate-wrap {
    display: flex;
    align-items: center;
    gap: 12px;
}

.login-btn {
    cursor: pointer;
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
    border-radius: 60px;
    background: #fff;
    color: #1664ff;
    border: 1px solid #1664ff;
    font-size: 16px;
    transition: all 0.2s;
    white-space: nowrap;
    &:hover {
        background: #1664ff;
        color: #fff;
    }
}

.auto-register-tip {
  font-size: 12px;
  color: #666;
  text-align: left;
  width: 100%;
  margin-bottom: 4px;

  .highlight-text {
    color: rgb(247, 144, 84);
  }

  .reset-pwd-link {
    color: $main_color;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
.hero-tag-wrapper {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
    flex-wrap: wrap;
    width: 100%;

    .hero-tag,
    .tech-arch-link {
        flex: 1;                     // 平分宽度
        justify-content: center;     // 文字居中
        min-width: 140px;            // 移动端不至于太窄
        white-space: nowrap;         // 保持单行
    }
}

.hero-tag {
    margin-bottom: 0;  // 覆盖原有 margin-bottom
}
.gradient-text {
    background: linear-gradient(135deg,rgb(19, 67, 243),rgb(130, 4, 248));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    display: inline-block;
}

.login-card .title,
.register-title {
    background: linear-gradient(135deg, #2e5bff, #7c3aed);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
    font-weight: 700 !important;   // 加 !important 强制覆盖
}

.login-card .operate-item,
.forget-card .operate-item {
    ::v-deep .el-button--primary {
        background: linear-gradient(135deg, #2e5bff, #7c3aed) !important;
        border-color: transparent !important;
        font-weight: 700 !important;
        &:hover {
            background: linear-gradient(135deg, #1a4bd6, #6b2ed6) !important;
            box-shadow: 0 8px 24px rgba(46, 91, 255, 0.3);
        }
    }
}

</style>

<style>
/* 修复拼图验证码被登录面板遮挡 */
.vue-puzzle-vcode {
  z-index: 9999 !important;
}
.vcode-mask {
  z-index: 9999 !important;
}

/* 仅针对核心能力区域及其内部元素，移除滤镜 */
.section,
.section * {
    opacity: 1 !important;
}
</style>